// To be used with Kd Data Tables and data-table.js
ko.bindingHandlers.sortableCol = {
  init: function(element, valueAccessor, allBindingsAccessor, column, bindingContext) {
    if(!_.isUndefined(column.sortable) && bindingContext.$parent.config.column_properties.sortable.enabled){
      let vm = bindingContext.$parent;
      let $el = $(element);
      $el.prepend('<i class=\'kf kf-back-arrow hidden\'></i>');
      $el.css('cursor', 'pointer');
      let $caret = $el.find('.kf-back-arrow');
      column.sortable = _.extend({}, { direction: ko.observable(''), sorting: ko.observable(false) }, column.sortable);

      column.sortable.direction.subscribe(function(value) {
        if(value === 'desc'){
          this.removeClass('hidden').addClass('up').removeClass('down');
          ko.bindingHandlers.sortableCol.sortCols(column, vm);
        } else if(value === 'asc') {
          this.addClass('down').removeClass('up');
          ko.bindingHandlers.sortableCol.sortCols(column, vm);
        } else {
          this.addClass('hidden');
        }
      }.bind(_.isUndefined($caret) ? this : $caret));

      column.sortable.sorting.subscribe(function(value){
        if(!value && this.sortable.direction() == '') {
          ko.bindingHandlers.sortableCol.sortByResetCol(vm);
        } else if(vm.config.row_properties.draggable.enabled) {
          vm.rowsDraggable(false);
        }
      }.bind(column));

      $el.on('click', function () {
        if(column.sortable.sorting() && column.sortable.direction() === 'asc') {
          column.sortable.direction('');
          column.sortable.sorting(false);
        } else {
          if(column.sortable.direction() === 'desc') {
            column.sortable.direction('asc');
            column.sortable.sorting(true);
          } else if(column.sortable.direction() === 'asc') {
            column.sortable.direction('');
            column.sortable.sorting(false);
          } else {
            column.sortable.direction('desc');
            column.sortable.sorting(true);
          }
        }
      });
    }
  },
  sortByResetCol: function(vm){
    let resetCol = _.find(vm.columns(), function(col) { return col.sortable.default; });
    if(_.isUndefined(resetCol)){
      resetCol = { property: 'order', sortable: { type: '' } };
    }
    ko.bindingHandlers.sortableCol.sortCols(resetCol, vm);
    if(vm.config.row_properties.draggable.enabled){
      vm.rowsDraggable(true);
    }
  },
  sortCols: function(column, vm) {
    ko.bindingHandlers.sortableCol.resetCols(column, vm);
    let sorted = _.sortBy(vm.rows(), function(data) {
      if (column.sortable.type == 'date') {
        return moment(data[column.property]()).utc();
      } else if (column.sortable.type == 'string') {
        return data[column.property]().toLowerCase();
      } else {
        return data[column.property]();
      }
    });

    if(!_.isUndefined(column.sortable.direction)) {
      sorted = (column.sortable.direction() === 'asc') ? sorted.reverse() : sorted;
    }

    vm.rows(sorted);
  },
  resetCols: function(column, vm) {
    let filteredCols = _.each(vm.columns(), function(col) {
      if(!_.isUndefined(col.sortable.direction) && col != column) {
        col.sortable.direction('');
      }
    });
    vm.columns(filteredCols);
  }
};

ko.bindingHandlers.editableCell = {
  init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
    let row = bindingContext.row;
    let property = bindingContext.column.property;
    let $element = $(element);
    $element.focus();

    if(valueAccessor().onBlur){
      $element.off('blur').on('blur', function () {
        row[property](this.value);
        valueAccessor().callback();
      });
    }

    if(valueAccessor().onEnter) {
      $element.off('keydown').on('keydown', function(evt) {
        if(evt.which == 13){
          row[property](this.value);
          valueAccessor().callback();
        }
      });
    }
  }
};
